export default _private => {
    const { startPromise, collection } = _private;
    return function clear() {
        return startPromise.then(() => {
            return collection.clear();
        });
    };
};
